(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-header-global"]) return;
  try {
    
/* HB — One preference for the storefront and its embedded HB pages. */
(() => {
  'use strict';
  if (window.HBColorMode) return;
  const configNode = document.getElementById('hb-color-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const key = 'hb-color-mode-v1';
  const root = document.documentElement;
  const system = matchMedia('(prefers-color-scheme: light)');
  const hosts = new Set();
  const mobileHeader = matchMedia('(max-width:749px)');
  const boundButtons = new WeakSet();
  let choice;
  try { choice = localStorage.getItem(key); } catch (_) { /* Optional persistence. */ }
  const valid = value => value === 'light' || value === 'dark';
  if (!valid(choice)) choice = null;
  const resolve = () => choice || (config.defaultMode === 'system' ? (system.matches ? 'light' : 'dark') : config.defaultMode === 'light' ? 'light' : 'dark');
  const icons = '<svg class="hb-color-toggle__sun" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.4 1.4m11.2 11.2L19 19M5 19l1.4-1.4M17.6 6.4L19 5"/></svg><svg class="hb-color-toggle__moon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.4 15.2A8.8 8.8 0 0 1 8.8 3.6a8.8 8.8 0 1 0 11.6 11.6Z"/></svg>';

  function syncButtons() {
    const mode = root.dataset.hbColorMode;
    document.querySelectorAll('[data-hb-color-toggle]').forEach(button => {
      const label = mode === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre';
      button.setAttribute('aria-label', label);
      button.title = label;
      button.dataset.mode = mode;
    });
  }

  function syncHost(host) {
    if (!host.isConnected) { hosts.delete(host); return; }
    const content = host.shadowRoot?.querySelector('#hbui-inline-content');
    if (!content) return;
    content.dataset.hbColorMode = root.dataset.hbColorMode;
    content.style.colorScheme = root.dataset.hbColorMode;
    const parent = host.closest('hb-univers-interactif');
    if (parent && parent.dataset.embeddedDesign !== 'false') {
      const style = getComputedStyle(parent);
      ['bg', 'panel', 'accent', 'ink'].forEach(name => {
        host.style.setProperty('--hb-embedded-' + name, style.getPropertyValue('--' + name).trim());
      });
    }
  }

  function registerShadow(host) {
    const shadow = host.shadowRoot;
    if (!shadow || !shadow.querySelector('#hbui-inline-content')) return;
    if (!shadow.querySelector('[data-hb-color-styles]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = config.stylesheet;
      link.dataset.hbColorStyles = '';
      shadow.append(link);
    }
    hosts.add(host);
    syncHost(host);
  }

  function apply() {
    const mode = resolve();
    root.dataset.hbColorMode = mode;
    root.style.colorScheme = mode;
    syncButtons();
    hosts.forEach(syncHost);
    document.dispatchEvent(new CustomEvent('hb:color-mode', { detail: { mode } }));
  }

  function setMode(mode) {
    if (!valid(mode)) return;
    choice = mode;
    try { localStorage.setItem(key, mode); } catch (_) { /* Continue in this page. */ }
    apply();
  }

  function scan(node) {
    if (!(node instanceof Element) && node !== document) return;
    const headers = new Set(node.querySelectorAll('hb-global-header'));
    const owner = node.closest?.('hb-global-header');
    if (owner) headers.add(owner);
    headers.forEach(header => {
      const mobileSlot = header.querySelector('[data-hbg-mobile-theme]');
      const container = (mobileHeader.matches && mobileSlot) || header.querySelector('.hbg-actions');
      if (!container) return;
      let button = header.querySelector('[data-hb-color-toggle]');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button'; button.className = 'hb-color-toggle';
        button.dataset.hbColorToggle = ''; button.innerHTML = icons;
      }
      if (!boundButtons.has(button)) {
        button.addEventListener('click', () => setMode(root.dataset.hbColorMode === 'dark' ? 'light' : 'dark'));
        boundButtons.add(button);
      }
      if (button.parentElement !== container) container.prepend(button);
    });
    const embedded = [...node.querySelectorAll('.hbui-inline-page')];
    if (node.matches?.('.hbui-inline-page')) embedded.push(node);
    embedded.forEach(registerShadow);
    syncButtons();
  }

  window.HBColorMode = { setMode, registerShadow, get mode() { return root.dataset.hbColorMode; } };
  function start() {
    scan(document); apply();
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
      hosts.forEach(host => { if (!host.isConnected) hosts.delete(host); });
    }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    choice = valid(event.newValue) ? event.newValue : null;
    apply();
  });
  mobileHeader.addEventListener('change', () => scan(document));
  system.addEventListener('change', () => { if (!choice && config.defaultMode === 'system') apply(); });
  window.addEventListener('pageshow', () => {
    try { const saved = localStorage.getItem(key); choice = valid(saved) ? saved : null; } catch (_) {}
    apply();
  });
})();

(() => {
  if (customElements.get('hb-global-header')) return;
  customElements.define('hb-global-header', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.data = JSON.parse(this.querySelector('[data-hbg-config]').textContent);
      this.home = {title: 'Accueil', url: this.data.home};
      this.key = 'hb-parent-path-v1';
      this.path = url => {
        try { const u = new URL(url, location.origin); return u.origin === location.origin ? u.pathname.replace(/\/collections\/[^/]+\/products\//, '/products/').replace(/\/$/, '') || '/' : null; }
        catch { return null; }
      };
      const current = this.path(location.href);
      const canonical = this.path(this.data.url);
      this.paths = new Map();
      const walk = (items, parents) => items.forEach(item => {
        const path = this.path(item.url);
        const chain = path === this.path(this.home.url) ? [this.home] : [...parents, {title:item.title, url:item.url}];
        if (path && !this.paths.has(path)) this.paths.set(path, chain);
        walk(item.children || [], chain);
      });
      walk(this.data.menu, [this.home]);
      let chain = this.paths.get(current) || this.paths.get(canonical);
      if (!chain && this.data.type === 'product') {
        for (const url of this.data.collections) {
          if (this.paths.has(this.path(url))) { chain = [...this.paths.get(this.path(url)), {title:this.data.title,url:this.data.url}]; break; }
        }
      }
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.key) || 'null');
        if (saved && saved.to === current && Date.now() - saved.at < 1800000 && Array.isArray(saved.chain)) {
          const safe = saved.chain.filter(x => typeof x.title === 'string' && this.path(x.url));
          if (safe.length && safe.length < 10) chain = [...safe, {title:this.data.title,url:this.data.url}];
        }
      } catch {}
      this.chain = chain || (current === this.path(this.home.url) ? [this.home] : [this.home, {title:this.data.title,url:this.data.url}]);
      this.chain[this.chain.length - 1].url = location.pathname + location.search + location.hash;
      this.draw();
      this.setupMobileSearch(signal);
      this.setupThemeControls(signal);
      this.setupUniverseDrawer(signal);
      this.setupDesktopMenu(signal);
      document.addEventListener('click', event => {
        const a = event.target.closest('a[href]');
        if (!a || a.hasAttribute('download') || a.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const to = this.path(a.href);
        if (!to || to === current || !/\/(products|collections)\//.test(to) || this.contains(a)) return;
        if (!['page','collection'].includes(this.data.type)) return;
        try { sessionStorage.setItem(this.key, JSON.stringify({to, at:Date.now(), chain:this.chain})); } catch {}
      }, {capture:true,signal});
      const resize = () => document.documentElement.style.setProperty('--hb-global-height', `${this.parentElement.getBoundingClientRect().height}px`);
      this.observer = new ResizeObserver(resize); this.observer.observe(this.parentElement); resize();
      // Le panier Origin remplace le contenu de #cart-icon-bubble après un ajout.
      // Conserver la présentation HB tout en reprenant son compteur actualisé.
      const cartLink = this.querySelector('[data-hbg-cart]');
      const cartMarkup = cartLink.innerHTML;
      this.cartObserver = new MutationObserver(() => {
        if (cartLink.querySelector('[data-hbg-count]')) return;
        const nativeCount = cartLink.querySelector('.cart-count-bubble [aria-hidden="true"]');
        const countValue = nativeCount ? Number(nativeCount.textContent.trim()) : 0;
        cartLink.innerHTML = cartMarkup;
        const count = cartLink.querySelector('[data-hbg-count]');
        count.textContent = Number.isFinite(countValue) ? countValue : 0;
        count.setAttribute('aria-label', `${count.textContent} articles`);
      });
      this.cartObserver.observe(cartLink, {childList:true});
      const cart = () => this.refreshCart();
      window.addEventListener('pageshow', cart, {signal});
      window.addEventListener('focus', cart, {signal});
      document.addEventListener('cart:updated', cart, {signal});
      this.querySelector('[data-hbg-cart]').addEventListener('pointerenter', cart, {signal});
      this.querySelector('[data-hbg-cart]').addEventListener('focus', cart, {signal});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, cart);
    }
    setupDesktopMenu(signal) {
      this.closeDesktopMenu?.();
      const nav = this.querySelector('[data-hbg-desktop-nav]');
      const backdrop = this.querySelector('[data-hbg-menu-backdrop]');
      if (!nav || !backdrop) return;
      const menus = [...nav.querySelectorAll('[data-hbg-mega]')];
      const hover = matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
      let openTimer, closeTimer, keyboardFocus = false;
      const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
      const sync = () => {
        const hasOpen = menus.some(menu => menu.open);
        backdrop.hidden = !hasOpen;
        menus.forEach(menu => menu.querySelector(':scope > summary').setAttribute('aria-expanded', String(menu.open)));
        if (!hasOpen) return;
        const bottom = Math.max(0, nav.getBoundingClientRect().bottom);
        this.style.setProperty('--hbg-menu-bottom', `${bottom}px`);
        this.style.setProperty('--hbg-mega-max-height', `${Math.max(96, innerHeight - bottom - 16)}px`);
      };
      const closeAll = () => { clearTimers(); menus.forEach(menu => { menu.open = false; }); sync(); };
      const open = menu => { clearTimers(); menus.forEach(other => { other.open = other === menu; }); sync(); };
      const closeSoon = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!keyboardFocus || !nav.contains(document.activeElement)) closeAll();
        }, 220);
      };
      this.closeDesktopMenu = closeAll;
      nav.querySelectorAll(':scope > ul > li').forEach(item => {
        item.addEventListener('pointerenter', event => {
          if (!hover.matches || event.pointerType !== 'mouse') return;
          keyboardFocus = false; clearTimers();
          const menu = item.querySelector(':scope > [data-hbg-mega]');
          if (menu) openTimer = setTimeout(() => open(menu), 120);
          else closeSoon();
        }, {signal});
        item.addEventListener('pointerleave', () => clearTimeout(openTimer), {signal});
      });
      nav.addEventListener('pointerenter', () => clearTimeout(closeTimer), {signal});
      nav.addEventListener('pointerleave', event => {
        if (!hover.matches || event.pointerType !== 'mouse') return;
        clearTimeout(openTimer); closeSoon();
      }, {signal});
      nav.addEventListener('pointerdown', () => { keyboardFocus = false; clearTimers(); }, {signal});
      nav.addEventListener('toggle', event => {
        const menu = event.target;
        if (!menus.includes(menu)) return;
        if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
        sync();
      }, {capture:true,signal});
      nav.addEventListener('keydown', event => {
        keyboardFocus = true; clearTimers();
        const menu = event.target.closest('[data-hbg-mega]');
        if (!menu) return;
        if (event.key === 'ArrowDown' && event.target === menu.querySelector(':scope > summary')) {
          event.preventDefault(); open(menu); menu.querySelector('.hbg-mega-panel a[href]')?.focus();
        } else if (event.key === 'Escape' && menu.open) {
          event.preventDefault(); event.stopPropagation(); closeAll();
          menu.querySelector(':scope > summary').focus({preventScroll:true});
        }
      }, {signal});
      nav.addEventListener('click', event => { if (event.target.closest('a[href]')) closeAll(); }, {signal});
      nav.addEventListener('focusout', event => { if (event.relatedTarget && !nav.contains(event.relatedTarget)) closeAll(); }, {signal});
      document.addEventListener('click', event => { if (!nav.contains(event.target)) closeAll(); }, {signal});
      window.addEventListener('scroll', sync, {passive:true,signal});
      window.addEventListener('resize', closeAll, {signal});
      window.addEventListener('pagehide', closeAll, {signal});
      sync();
    }
    setupThemeControls(signal) {
      const buttons = this.querySelectorAll('[data-hbg-theme-toggle]');
      if (!buttons.length) return;
      const sync = () => {
        const mode = document.documentElement.dataset.hbColorMode === 'light' ? 'light' : 'dark';
        buttons.forEach(button => {
          button.dataset.mode = mode;
          button.setAttribute('aria-label', mode === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre');
        });
      };
      sync();
      buttons.forEach(button => button.addEventListener('click', () => {
        window.HBColorMode?.setMode(document.documentElement.dataset.hbColorMode === 'dark' ? 'light' : 'dark');
      }, {signal}));
      document.addEventListener('hb:color-mode', sync, {signal});
    }
    setupMobileSearch(signal) {
      this.searchToggle = this.querySelector('[data-hbg-search-toggle]');
      this.searchForm = this.querySelector('.hbg-search');
      this.searchInput = this.searchForm?.querySelector('input[name="q"]');
      if (!this.searchToggle || !this.searchInput) return;
      this.mobileToolsMedia = matchMedia('(max-width:749px)');
      this.classList.add('hbg-mobile-tools-ready');
      this.setMobileSearch(false, false);
      this.searchToggle.addEventListener('click', () => {
        if (this.mobileToolsMedia.matches) this.setMobileSearch(!this.classList.contains('hbg-search-open'));
      }, {signal});
      this.searchForm.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.mobileToolsMedia.matches) {
          event.preventDefault(); this.setMobileSearch(false);
        }
      }, {signal});
      this.mobileToolsMedia.addEventListener('change', () => this.setMobileSearch(false, false), {signal});
      window.addEventListener('pagehide', () => this.setMobileSearch(false, false), {signal});
    }
    setMobileSearch(open, moveFocus = true) {
      this.classList.toggle('hbg-search-open', open);
      this.searchToggle?.setAttribute('aria-expanded', String(open));
      this.searchToggle?.setAttribute('aria-label', open ? 'Fermer la recherche' : 'Rechercher');
      if (moveFocus) (open ? this.searchInput : this.searchToggle)?.focus({preventScroll:true});
    }
    setupUniverseDrawer(signal) {
      this.drawer = this.querySelector('[data-hbg-drawer]');
      this.drawerTrigger = this.querySelector('[data-hbg-drawer-open]');
      if (!this.drawer || !this.drawerTrigger || typeof this.drawer.showModal !== 'function') return;
      this.drawerMedia = matchMedia('(max-width:749px)');
      this.classList.add('hbg-drawer-ready');
      const parent = this.chain[this.chain.length - 2] || this.home;
      const back = this.drawer.querySelector('[data-hbg-drawer-back]');
      back.href = parent.url;
      back.textContent = parent.url === this.home.url ? '← Retour à l’accueil' : `← Retour à ${parent.title}`;
      this.drawerTrigger.addEventListener('click', () => {
        if (!this.drawerMedia.matches || this.drawer.open) return;
        this.setMobileSearch(false, false);
        this.drawer.showModal();
        this.drawerTrigger.setAttribute('aria-expanded','true');
        this.syncDrawerScrollLock();
      }, {signal});
      this.drawer.querySelector('[data-hbg-drawer-close]').addEventListener('click', () => this.closeUniverseDrawer(), {signal});
      this.drawer.addEventListener('cancel', event => { event.preventDefault(); this.closeUniverseDrawer(); }, {signal});
      this.drawer.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.drawer.querySelectorAll('a[href],button:not([disabled])')].filter(node => node.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }, {signal});
      this.drawer.addEventListener('close', () => {
        this.drawerTrigger.setAttribute('aria-expanded','false');
        this.syncDrawerScrollLock();
      }, {signal});
      this.drawer.addEventListener('click', event => {
        const toggle = event.target.closest('[data-hbg-submenu-toggle]');
        if (toggle) {
          const list = document.getElementById(toggle.getAttribute('aria-controls'));
          if (!list || !this.drawer.contains(list)) return;
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          const item = toggle.closest('li');
          const group = item?.parentElement;
          if (expanded && group?.closest('.hbg-drawer-nav')) {
            [...group.children].forEach(other => {
              if (other === item) return;
              other.querySelectorAll('[data-hbg-submenu-toggle]').forEach(button => {
                button.setAttribute('aria-expanded', 'false');
                const submenu = document.getElementById(button.getAttribute('aria-controls'));
                if (submenu && this.drawer.contains(submenu)) submenu.hidden = true;
              });
            });
          }
          toggle.setAttribute('aria-expanded',String(expanded));
          list.hidden = !expanded;
          return;
        }
        if (event.target.closest('a[href]')) { this.closeUniverseDrawer(false); return; }
        if (event.target === this.drawer) {
          const rect = this.drawer.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeUniverseDrawer();
        }
      }, {signal});
      this.drawerMedia.addEventListener('change', () => { if (!this.drawerMedia.matches) this.closeUniverseDrawer(false); }, {signal});
      window.addEventListener('pagehide', () => this.closeUniverseDrawer(false), {signal});
    }
    syncDrawerScrollLock() {
      document.documentElement.classList.toggle('hbg-universe-drawer-open',Boolean(document.querySelector('[data-hbg-drawer][open]')));
    }
    closeUniverseDrawer(restoreFocus = true) {
      if (!this.drawer) return;
      const wasOpen = this.drawer.open;
      if (wasOpen) this.drawer.close();
      this.drawerTrigger?.setAttribute('aria-expanded','false');
      this.syncDrawerScrollLock();
      if (wasOpen && restoreFocus && this.drawerTrigger?.isConnected && this.drawerMedia?.matches) this.drawerTrigger.focus({preventScroll:true});
    }

    draw() {
      const list = this.querySelector('[data-hbg-crumbs]');
      const back = this.querySelector('[data-hbg-back]');
      if (!list || !back) return;
      list.replaceChildren();
      this.chain.forEach((item, index) => {
        const li = document.createElement('li');
        const el = document.createElement(index === this.chain.length - 1 ? 'span' : 'a');
        el.textContent = item.title;
        if (el.tagName === 'A') el.href = item.url;
        else el.setAttribute('aria-current','page');
        li.append(el); list.append(li);
      });
      const parent = this.chain[this.chain.length - 2] || this.home;
      back.href = parent.url; back.textContent = `← ${parent.title}`;
    }
    async refreshCart() {
      if (this.busy) return;
      this.busy = true;
      try {
        const r = await fetch(this.data.home.replace(/\/?$/, '/') + 'cart.js', {signal:this.abort.signal});
        if (!r.ok) return;
        const cart = await r.json();
        const count = this.querySelector('[data-hbg-count]');
        count.textContent = cart.item_count;
        count.setAttribute('aria-label', `${cart.item_count} articles`);
      } catch {} finally { this.busy = false; }
    }
    disconnectedCallback() { this.closeDesktopMenu?.(); this.closeUniverseDrawer(false); this.setMobileSearch(false, false); this.classList.remove('hbg-drawer-ready','hbg-mobile-tools-ready'); this.abort?.abort(); this.observer?.disconnect(); this.cartObserver?.disconnect(); this.unsubscribe?.(); }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
